export interface PinAppResponse {
  success: boolean
  data: unknown
}
